import { HHStack } from '@hinge-health/react-component-library';
import TablePagination from '@mui/material/TablePagination';

export interface ProgramCapGridFooterProps {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  rowsPerPageOptions?: number[];
}

export const ProgramCapGridFooter = ({
  totalItems,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  rowsPerPageOptions = [5, 10, 20, 50],
}: ProgramCapGridFooterProps): JSX.Element => {
  const handlePageChange = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ): void => {
    onPageChange(newPage + 1); // TablePagination uses 0-based indexing
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    const newPageSize = parseInt(event.target.value, 10);
    onPageSizeChange(newPageSize);
    onPageChange(1);
  };

  return (
    <HHStack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      paddingRight={2}
      paddingLeft={2}
      paddingY={1}
      sx={{
        minHeight: '48px',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
      }}
    >
      <TablePagination
        component="div"
        count={totalItems}
        page={currentPage - 1} // TablePagination uses 0-based indexing
        onPageChange={handlePageChange}
        rowsPerPage={pageSize}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        sx={{ padding: 0 }}
        labelDisplayedRows={({ from, to, count }): string =>
          `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
        }
        labelRowsPerPage="Items per page:"
      />
    </HHStack>
  );
};
